<script setup>
import { ref } from "vue";
import BaseModalSimple from "@/Components/UI/modals/BaseModalSimple.vue";
import BaseIcon from "@/Components/UI/BaseIcon.vue";

defineOptions({
    inheritAttrs: false,
});

defineProps({
    text: {
        type: String,
        required: true,
    },
});

const modalOpened = ref(false);

const handleMobileClick = (e) => {
    if (window.innerWidth <= 768) {
        e.preventDefault();
        e.stopPropagation();
        modalOpened.value = true;
    }
};
</script>

<template>
    <!-- No illustration here on purpose: the reader tapped a «?» and the title
         already says «Подсказка», so a third question mark inside the panel is
         pure repetition — and it pushed a two-line hint into a tall dialog. -->
    <BaseModalSimple class="md:hidden"
                     :show="modalOpened"
                     @close="modalOpened = false">
        <template #title>
            Подсказка
        </template>
        <template #description>
            {{ text }}
        </template>
    </BaseModalSimple>

    <span
        v-bind="$attrs"
        @click="handleMobileClick"
        tabindex="0"
        class="help-tooltip-trigger inline-flex mr-2 align-middle items-center justify-center cursor-pointer text-dark-light hover:text-accent-blue transition-colors duration-200 outline-none shrink-0 w-9 h-9 relative z-10"
        v-tooltip.focus.top="text"
        v-tooltip.hover.top="text">
        <BaseIcon
            aria-hidden="true"
            class="w-full h-full"
            name="circle-help" />
    </span>
</template>

<style scoped>
/* Thinner stroke: the lucide circle-help renders at stroke-width 2, which reads
   heavy at this small size. CSS overrides the SVG presentation attribute. */
.help-tooltip-trigger :deep(svg) {
    stroke-width: 1.5px;
}
</style>
